<template>
<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-required`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.41817 1.10156C4.52862 1.10156 4.61812 1.19118 4.61812 1.30164L4.61726 3.34656L6.45369 2.75024C6.55874 2.71611 6.6715 2.77349 6.70564 2.87854L6.95296 3.6394C6.98709 3.74445 6.92959 3.85735 6.82454 3.89148L4.9742 4.49158L6.19942 6.17822C6.26434 6.26758 6.24459 6.3926 6.15523 6.45752L5.50801 6.92773C5.41865 6.99265 5.29351 6.97291 5.22859 6.88354L3.96223 5.13953L2.68904 6.8927C2.62412 6.98206 2.49898 7.00194 2.40962 6.93701L1.7624 6.4668C1.67304 6.40188 1.65329 6.27674 1.71821 6.18738L2.97322 4.45764L1.16853 3.87158C1.06348 3.83745 1.00598 3.72468 1.04011 3.61963L1.28731 2.85876C1.32144 2.75371 1.43421 2.69622 1.53926 2.73035L3.41719 3.3396L3.41817 1.30164C3.41817 1.19118 3.50766 1.10156 3.61812 1.10156H4.41817Z" :fill="useCurrentColor ? 'currentColor' : '#F53F3F'"/></svg>
</template>
<script>

export default {
  name: 'IconColorRequired',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
